<template>
  <div class="homepage">
    <div class="homepage__slider__background--large" :style="`background-image: url('${currentVideo.bgURL}')`"></div>
    <div class="homepage__play-video" @click="openVideo(currentVideo)"><img class="homepage__play-video__icon" src="../assets/play-button.svg"></div>
    <div class="homepage__info">
      <div class="homepage__header">
        <div class="homepage__header__logo">
          <img src="../assets/logo.png" class="main-logo" />
          <p class="homepage__slogan">
            Interviews on democracy’s<br />past, present, and future.
          </p>
          <h2>Season {{ currentVideo.season }}</h2>
        </div>
        <div class="homepage__header__logos" style="text-align:right;">
          <div class="homepage__header__logo">
            <img src="../assets/bertelsmann-logo.png" alt="Bertelsmann Foundation" class="sponsor-logo" />
          </div>
          <div class="homepage__header__logo">
            <img src="../assets/HIA_Logo-white.png" alt="Humanity in Action" class="sponsor-logo" />
          </div>
        </div>
      </div>
    </div>
      <div class="homepage__footer" v-show="hasVideos">
        <div class="homepage__author-wrapper">
          <div class="homepage__author" :style="{ backgroundImage: `url('${getAuthorPicture(currentVideo)}')` }"></div>
          <div class="homepage__main-info">
            <h1>{{ currentVideo.title }}</h1>
            <ul class="video-description__tabs tabs">
              <li class="tabs__item"><a href="#" class="tabs__link" :class="{ 'active' : selectedTab == 'desc' }" @click.prevent="selectedTab='desc'">Description</a></li>
              <li class="tabs__item"><a href="#" class="tabs__link" :class="{ 'active' : selectedTab == 'bio' }" @click.prevent="selectedTab='bio'">Bio</a></li>
            </ul>
          </div>
        </div>
        <div class="homepage__description">
          <perfect-scrollbar class="video-description__text" v-if="selectedTab == 'desc'">
            {{ currentVideo.description }}
          </perfect-scrollbar>
          <perfect-scrollbar class="video-description__text" v-else>
            {{ currentVideo.bio }}
          </perfect-scrollbar>
        </div>
        <div class="social-icons">
          <b class="podcast-icon" style="cursor:pointer;" title="Suggested tweet" @click="openSuggestedTweet" target="_blank" rel="noopener" v-if="currentVideo.suggestedTweet">
            <img alt="Suggested tweet" src="/img/icons/twitter.svg" class="social-icons__icon" />
          </b>
          <a class="podcast-icon" :href="currentVideo.googlePodcastsUrl" title="Google Podcasts" target="_blank" rel="noopener" v-if="currentVideo.googlePodcastsUrl">
            <img alt="Google Podcasts" src="/img/icons/google-podcasts.svg" />
          </a>
          <a class="podcast-icon" :href="currentVideo.itunesUrl" title="iTunes" target="_blank" rel="noopener" v-if="currentVideo.itunesUrl">
            <img alt="iTunes" src="/img/icons/podcasts.svg" class="social-icons__icon" />
          </a>
          <a class="podcast-icon" :href="currentVideo.spotifyUrl" title="Spotify" target="_blank" rel="noopener" v-if="currentVideo.spotifyUrl">
            <img alt="Spotify" src="/img/icons/spotify.svg" class="social-icons__icon" />
          </a>
        </div>
      </div>
  </div>
</template>

<style lang="scss" scoped>
.homepage__slider__background--large {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #000000;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  opacity: 0.67;
}

.main-logo {
  width: 37vw;
}

.sponsor-logo {
  width: 20vw;
}

.tabs {
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  padding: 0;
  margin: 0;
}

  .tabs__link {
    font-size: 0.75em;
    font-weight: 700;
    display: block;
    line-height: 1em;
    text-transform: uppercase;
    color: #FFF;
    margin-right: 20px;
    &:hover,
    &:visited,
    &:focus,
    &:active {
      text-decoration: none;
    }

    &:hover,
    &:focus,
    &.active {
      color: #FC8B00;
    }
  }

.video-description__text {
  font-size: 0.75em;
  height: 90px;
  font-weight: 300;
  line-height: 18px;
}

.social-icons {
  display: flex;
  flex-flow: row nowrap;
  gap: 18px;
}

  .social-icons__icon {
    height: 21px;
  }

.homepage {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  &__play-video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    width: 70px;
    z-index: 9;
    img {
      width: 100%;
    }
  }

  &__main-info {
    flex: 1;
    h1 {
      font-size: 1em;
      font-weight: 700;
      text-transform: uppercase;
      margin-bottom: 9px;
    }
  }

  &__slogan {
    font-size: 0.875em;
    font-weight: 400;
    line-height: 20px;
    margin: 9px 0 0 0;
  }

  &__info {
    position: absolute;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 32px 30px 80px;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    pointer-events: none;
    user-select: none;
    // background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 47%, #0a0a0a 100%);
    background-color: rgba(0, 0, 0, 0.48);
  }

  &__header {
    display: flex;
    justify-content: space-between;
    padding: 0 16px;

    &__logo {
      display: block;
      width: 60%;

      & + & { margin-top: 10px; }
      h2 {
        padding-top: 20px;
        color: #fc8b00;
        font-size: 1em;
        font-weight: 700;
        letter-spacing: 2.75px;
        text-transform: uppercase;
      }
    }
  }

  &__footer {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    position: absolute;
    width: calc(100% - 60px);
    left: 30px;
    bottom: 80px;
  }

  &__author {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    margin-left: -8px;

    &-wrapper {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      gap: 18px;
    }
  }

  &__description {
    flex: 1;
    padding-top: 8px;
    // margin-left: 32px;

    h2 {
      color: #fc8b00;
      font-size: 0.875em;
      font-weight: 700;
      letter-spacing: 2px;
      text-transform: uppercase;
      margin: 0;
    }

    h1 {
      color: #ffffff;
      font-size: 1.5em;
      font-weight: 300;
      letter-spacing: 5px;
      line-height: 32px;
      text-transform: uppercase;
      margin: 4px 0;
    }

    p {
      color: #ffffff;
      font-size: 0.875em;
      font-weight: 300;
      margin: 0;
    }
  }

  &__controls {
    @extend .material-icons;
    position: absolute;
    background-color: #fc8b00;
    padding: 12px;
    font-size: 36px;
    box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.25);
    top: 33%;
    cursor: pointer;
    user-select: none;
    transform: translateY(-50%);
    z-index: 10;

    &--left {
      left: 0;
    }

    &--right {
      right: 0;
    }
  }
}
</style>

<script>
import utils from '../utils'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
export default {
  name: 'HomepageUILargeComponent',
  components: { PerfectScrollbar },
  data () {
    return {
      selectedTab: 'desc'
    }
  },
  computed: {
    videoList () {
      return this.$store.state.videoList
    },
    currentIndex () {
      return this.$store.state.currentVideo
    },
    hasVideos () {
      return this.$store.getters.hasVideos
    },
    currentVideo () {
      return this.hasVideos ? this.videoList[this.currentIndex] : this.$store.getters.emptyEpisode
    }
  },
  methods: {
    setCurrentVideo (index) {
      this.$store.commit('setCurrentVideo', index)
    },
    getAuthorPicture (episode) {
      if (this.hasVideos && episode.authors.length > 0) {
        return episode.authors[0].picture.url
      } else {
        return ''
      }
    },
    openVideo (video) {
      const videoId = utils.getVideoIdFromYoutubeUrl(video.videoUrl)
      if (!videoId) {
        alert(`Couldn't play video:\nvideo ID not found in "${video.videoUrl}".`)
      }
      this.$store.commit('setHomepageVideoEffect', true)
      setTimeout(() => {
        this.$router.push({ name: 'watchVideoId', params: { videoId } })
      }, 330)
    }
  }
}
</script>
